/**
 * AntragSigniertUploadDialog - broker upload of the signed Antrag (Tab 5a, P2 Slice 13).
 */

import { useState } from 'react';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

const ERROR_TEXT: Record<string, string> = {
  invalid_mime_type: 'Nur PDF, JPEG oder PNG',
  bereits_unterschrieben: 'Ein unterschriebener Antrag ist bereits eingegangen',
  file_empty: 'Bitte eine Datei auswaehlen',
};

export function AntragSigniertUploadDialog({
  open,
  onClose,
  onUpload,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  onUpload: (file: File) => void;
  saving: boolean;
  error: { code?: string } | null;
}) {
  const [file, setFile] = useState<File | null>(null);
  const errorText = error?.code ? (ERROR_TEXT[error.code] ?? 'Hochladen fehlgeschlagen') : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Unterschriebenen Antrag hochladen"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
          <Button disabled={saving || !file} onClick={() => file && onUpload(file)} data-testid="antrag-signiert-submit">
            Hochladen
          </Button>
        </div>
      }
    >
      <div className="space-y-3 text-sm" data-testid="antrag-signiert-dialog">
        <p className="text-muted-foreground">Unterschriebenen Antrag hochladen (Scan oder Foto)</p>
        <input
          type="file"
          accept="application/pdf,image/jpeg,image/png"
          onChange={(e) => setFile(e.target.files?.[0] ?? null)}
          data-testid="antrag-signiert-input"
        />
        {errorText && <p className="text-sm text-status-danger" data-testid="antrag-signiert-error">{errorText}</p>}
      </div>
    </Dialog>
  );
}
